import { appConfig } from '@/app-config/appConfig'

export function isProductionEnvironment() {
	return appConfig.BUILD_MODE === 'production'
}
